module.exports = __webpack_public_path__ + "img/ugc.44d19173.svg";